<template>
  <div class="hello">
    <h3>{{ msg }}</h3>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Eing",
    };
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  width: 100%;
  height: 100vh;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(4, 15, 36);
}
h3 {
  /* text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -150%);
  width: 100%;
  text-align: center;
  font-size: 3em;
  text-transform: uppercase;
  letter-spacing: 10px;
  color: rgb(4, 15, 36);
  -webkit-box-reflect: below 1px
    linear-gradient(transparent, rgb(218, 218, 218));
  animation: san 6s linear 2;
  text-shadow: 0 0 5px rgb(22, 138, 216), 0 0 25px rgb(22, 138, 216),
      0 0 35px rgb(22, 138, 216), 0 0 105px rgb(22, 138, 216),
      0 0 155px rgb(22, 138, 216);
      color: rgb(255, 255, 255);
}
@keyframes san {
  25%,
  75% {
    color: rgb(82, 40, 180);
    filter: blur(2px);
  }

  0%,
  50%,
  100% {
    color: rgb(255, 255, 255);
    text-shadow: 0 0 5px rgb(22, 138, 216), 0 0 25px rgb(22, 138, 216),
      0 0 35px rgb(22, 138, 216), 0 0 105px rgb(22, 138, 216),
      0 0 155px rgb(22, 138, 216);
    filter: blur(0px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue